import styled from '@emotion/styled';

export const GreenLine = styled.span`
  height: 1px;
  width: 55px;
  background: ${({ theme }) => theme.gradients.green};
  display: black;
  margin-bottom: 10px;
`;
